import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excerpt',
})
export class ExcerptPipe implements PipeTransform {
  constructor() {}

  transform(text: string, length: number) {
    if (text.length <= length) {
      return text;
    }
    return text.substring(0, length) + '...';
  }
}
